module.exports = __webpack_public_path__ + "img/About_fw_6.cfb9c332.png";